import { TeethAnimation } from "@jasper/forms";
import { Box, Stack, Text, Title } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import {
  IconCalendarCheck,
  IconReceipt,
  IconScan,
  type Icon,
} from "@tabler/icons-react";

const useStyles = createStyles(theme => ({
  aside: {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 48,
    background: theme.colors.navy[6],
    "&::after": {
      content: '""',
      position: "absolute",
      inset: 0,
      background: theme.colors.navy[8],
      opacity: 0.55,
      maskImage:
        "radial-gradient(120% 90% at 78% 12%, transparent 0, #000 62%)",
      WebkitMaskImage:
        "radial-gradient(120% 90% at 78% 12%, transparent 0, #000 62%)",
      pointerEvents: "none",
    },
  },
  content: {
    position: "relative",
    zIndex: 1,
    maxWidth: 392,
  },
  quote: {
    lineHeight: 1.22,
    letterSpacing: "-0.02em",
  },
  quoteHighlight: {
    boxShadow: `inset 0 -.24em 0 ${theme.colors.brand[6]}`,
  },
  point: {
    display: "flex",
    alignItems: "flex-center",
    gap: 14,
  },
  pointIcon: {
    width: 38,
    height: 38,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 12,
    background: theme.colors.navy[5],
    border: `1px solid ${theme.colors.navy[4]}`,
    color: theme.colors.brand[2],
  },
}));

const POINTS: { icon: Icon; title: string; description: string }[] = [
  {
    icon: IconScan,
    title: "Direct Connect",
    description: "Les empreintes arrivent seules depuis votre scanner.",
  },
  {
    icon: IconCalendarCheck,
    title: "Dates de livraison",
    description: "Annoncées à la commande, suivies jusqu'à la réception.",
  },
  {
    icon: IconReceipt,
    title: "Une facture par mois",
    description: "Aucun paiement à la commande.",
  },
];

export const LoginAside = () => {
  const { classes } = useStyles();

  return (
    <Box component="aside" visibleFrom="md" className={classes.aside}>
      <TeethAnimation />

      <div className={classes.content}>
        <Title
          order={2}
          variant="display"
          size="md"
          c="white"
          mb="s12"
          className={classes.quote}
        >
          Vos commandes, vos empreintes et vos designs à valider,{" "}
          <span className={classes.quoteHighlight}>au même endroit</span>.
        </Title>

        <Stack gap="s6">
          {POINTS.map(({ icon: PointIcon, title, description }) => (
            <div key={title} className={classes.point}>
              <span className={classes.pointIcon}>
                <PointIcon size={18} stroke={1.75} />
              </span>
              <div>
                <Text variant="h5" fw={600} c="white">
                  {title}
                </Text>
                <Text variant="caption" c="navy.2">
                  {description}
                </Text>
              </div>
            </div>
          ))}
        </Stack>
      </div>
    </Box>
  );
};
